var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFacebook(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 20,
    viewBox: "0 0 11 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.1234 0.00416134L7.72488 0C5.0302 0 3.28878 1.9319 3.28878 4.92203V7.19141H0.877148C0.668755 7.19141 0.5 7.37409 0.5 7.59943V10.8875C0.5 11.1128 0.668947 11.2953 0.877148 11.2953H3.28878V19.5922C3.28878 19.8175 3.45753 20 3.66593 20H6.81242C7.02081 20 7.18957 19.8173 7.18957 19.5922V11.2953H10.0093C10.2177 11.2953 10.3865 11.1128 10.3865 10.8875L10.3876 7.59943C10.3876 7.49123 10.3478 7.38762 10.2772 7.31105C10.2066 7.23448 10.1103 7.19141 10.0103 7.19141H7.18957V5.26763C7.18957 4.34298 7.39334 3.87358 8.50727 3.87358L10.123 3.87295C10.3312 3.87295 10.5 3.69027 10.5 3.46514V0.411972C10.5 0.187052 10.3314 0.00457747 10.1234 0.00416134Z",
    fill: "#3A81B8"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.8cf0e5d0.svg";
export { ForwardRef as ReactComponent };